module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitlec"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("TABLE OF CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rint"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Introduction#int"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "rpt1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Part001#pt1"
    }
  }, [_vm._v("PART 1: Getting to Know Your Liver")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter001#ch1"
    }
  }, [_vm._v("Chapter 1: What does your liver do for you?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter001#sec1"
    }
  }, [_vm._v("The Anatomy of the Liver")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec2"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter001#sec2"
    }
  }, [_vm._v("Liver Function")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter002#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Liver Conditions & Common Lab Tests")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter002#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liver Disorders")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Non-Alcoholic Fatty Liver Disease (NAFLD) and Non-Alcoholic Steatohepatitis (NASH)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alcoholic Liver Disease")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hepatitis A")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hepatitis B")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hepatitis C")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec9"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cholestatic Liver Diseases")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec10"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drug-Induced Liver Injury")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec11"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iron Overload/Hereditary Hemochromatosis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec12"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Autoimmune Hepatitis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec13"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wilson’s Disease")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec14"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decompensated Cirrhosis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec15"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter002#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Common Laboratory Tests")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec16"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALT and AST Liver Enzymes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec17"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alkaline Phosphatase")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec18"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bilirubin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec19"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Albumin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec19a"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec19a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blood Coagulation")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "rpt2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Part002#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 2: Taking Care of Your Liver")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter003#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Nutrition 101")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec20"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter003#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Macronutrients")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec21"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter003#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Micronutrients")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec22"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter003#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Healthy Portion Sizes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec23"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter003#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Food Labels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Detoxify Your Body")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec24"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter004#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eliminate Toxins")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec25"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter004#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hydration—Flush Out the Toxins")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Healthy Foods for a Healthy Liver")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec26"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter005#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protein")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec27"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter005#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carbohydrates")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec28"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter005#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec29"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter005#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foods and Nutrients That Claim to Heal the Liver")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec30"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter005#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adding Extra Calories to Your Diet")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec31"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter005#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tips for Eating Healthy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Promoting Liver Health Through Exercise")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec32"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter006#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Exercise Promotes Health")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec33"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter006#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Kind of Exercise and How Much")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec34"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter006#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise and Liver Health")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Jump over Those Roadblocks")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec35"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter007#sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Busy Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec36"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter007#sec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traveling")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec37"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter007#sec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eating Out")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec38"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter007#sec38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emotional Eating")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec39"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter007#sec39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiday Parties")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "rpt3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Part003#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 3: Recipes for a Healthy Liver")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Breakfast")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec40"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter008#sec40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kamut Porridge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec41"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter008sec41#sec41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teff “Meal” with Dried Fruit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec42"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter008sec42#sec42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rye Porridge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec43"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter008sec43#sec43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry Oatmeal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec44"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter008sec44#sec44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Omelet with Mushrooms and Leeks")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec45"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter008sec45#sec45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scrambled Eggs with Asparagus and Peppers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Shakes & Smoothies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec46"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter009#sec46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exotic Fruit Smoothie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec47"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter009sec47#sec47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mixed Berry Smoothie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec48"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter009sec48#sec48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen Banana and Berry Smoothie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec49"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter009sec49#sec49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Almond Mocha Shake")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec50"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter009sec50#sec50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coco Mango Frappé")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec51"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter009sec51#sec51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry Kale Almond Smoothie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec52"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter009sec52#sec52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spinach Smoothie with Fruit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Snacks & Appetizers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec53"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter010#sec53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oatmeal Balls")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec54"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter010sec54#sec54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mixed Bean Salad with Homemade Whole Wheat Pita Chips")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec55"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter010sec55#sec55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Almond Trail Mix")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec56"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter010sec56#sec56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yogurt Dip")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter011#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Sandwiches, Soups, & Salads")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec57"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter011#sec57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roast Turkey Wrap")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec58"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter011sec58#sec58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roast Turkey")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec59"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter011sec59#sec59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Egg Salad Sandwich")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec60"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter011sec60#sec60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuna Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec61"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter011sec61#sec61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baby Spinach Salad with Vegetables and Grilled Chicken")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec62"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter011sec62#sec62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salad Dressing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec63"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter011sec63#sec63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato Soup with Chickpeas and Black Beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec64"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter011sec64#sec64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Mushroom Barley Soup")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec65"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter011sec65#sec65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetarian Farro Soup")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter012#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Pasta, Rice, & Grains")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec66"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter012#sec66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mashed Millet")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec67"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter012sec67#sec67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Wheat Spaghetti with Mixed Vegetables and Chickpeas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec68"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter012sec68#sec68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bulgur with Mixed Beans and Vegetables")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec69"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter012sec69#sec69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pasta with Green Vegetables")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec70"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter012sec70#sec70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Multigrain Pilaf")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec71"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter012sec71#sec71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato and Broccoli Rice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec72"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter012sec72#sec72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wheat Berry Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec73"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter012sec73#sec73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kamut Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter013#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Chicken, Beef, Pork, & Fish")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec74"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter013#sec74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ground Beef with Peas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec75"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter013sec75#sec75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp Stir-Fry with Mixed Vegetables")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec76"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter013sec76#sec76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quinoa with Grilled Chicken and Vegetables")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec77"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter013sec77#sec77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork Curry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec78"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter013sec78#sec78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Salmon with Indian Spices")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec79"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter013sec79#sec79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turkey Meatballs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec80"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter013sec80#sec80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuna Cakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec81"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter013sec81#sec81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spelt and Spicy Chicken Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch14"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter014#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Desserts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec82"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter014#sec82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Peaches with Dark Chocolate")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec83"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter014sec83#sec83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole-Grain Almond Bars")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec84"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter014sec84#sec84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen Chocolate-Covered Bananas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec85"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter014sec85#sec85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rice Pudding")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec86"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter014sec86#sec86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buckwheat Porridge")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "rapp"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Appendix#app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec87"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Appendix#sec87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grocery Lists")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec88"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Appendixsec88#sec88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sample Meal Plan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec89"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Appendixsec89#sec89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meal Planning Worksheet")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1",
    attrs: {
      "id": "rsec89a"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendixsec89#sec89a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Water Intake Log")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec90"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Appendixsec90#sec90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Physical Activity and Exercise Plan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec91"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Appendixsec91#sec91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10,000 Steps Program")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec92"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Appendixsec92#sec92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Evaluation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec",
    attrs: {
      "id": "rsec93"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Appendixsec93#sec93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rack"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "raut"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Author#aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0